import { useEffect, useState } from 'react';
import { jsx } from '@emotion/react';
/** @jsxImportSource @emotion/react */
import 'twin.macro';
import api from '@/api';
import { SubTitle } from '@/components/atoms';
import moment from 'moment';
import { FORMAT_DATE_GENERAL } from '@/constants/constant';
import { message, Popconfirm } from 'antd';

const AdminCompanyListPage = () => {
  const [listData, setListData] = useState<any>({
    company: [] as any[],
  });

  const fetchCompanyList = () => {
    api.get('/admin/company').then(({ data }) => {
      setListData(data);
    });
  };

  useEffect(() => {
    fetchCompanyList();
  }, []);

  const confirmCompany = (companyId: string | number) => {
    api
      .put(`/admin/company/${companyId}/confirm`)
      .then(() => fetchCompanyList())
      .catch(() => {
        message.error('승인에 실패했습니다.');
      });
  };
  return (
    <div className="px-5">
      <SubTitle>Company List</SubTitle>

      {listData.company?.map((item: any) => (
        <div key={`admin-company-list-${item.base?.id}`} tw="bg-white my-4 rounded-lg flex" style={{ minHeight: '100px' }}>
          <div className="flex flex-grow-0 justify-center items-center p-4">{item.base?.id}</div>
          <div className="flex flex-col flex-grow p-4">
            <div>
              {item.name} - {item.no}
            </div>
            <div>
              {item.addr1} {item.addr2}
            </div>
          </div>
          <div className="flex flex-grow-0  p-4 justify-center items-center text-xs">{moment(item.createdAt).format(FORMAT_DATE_GENERAL)}</div>
          <div className="flex flex-grow-0 p-4 justify-center items-center">
            {item.statusCode === 100 && (
              <Popconfirm title="승인하시겠습니까?" onConfirm={() => confirmCompany(item.base?.id)}>
                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">{item.statusName}</span>
              </Popconfirm>
            )}
            {item.statusCode === 200 && (
              <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">{item.statusName}</span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AdminCompanyListPage;
